import React from 'react';
import { DatePicker, Space } from 'antd';
import { utcMoment } from '@src/components/usage-dashboard/utils';
import GranularityPicker from './GranularityPicker';
import { Kebab } from '../../KebabIcon/Kebab';
import { IUsageDatePickerProps } from './typed';
import { useSelector } from 'react-redux';
import { featureSelector } from '@store/common/selectors';
import { usageDashboardFeatureNames } from '@utils/featureToggle/constants';
import moment from 'moment';

const { RangePicker } = DatePicker;

const UsageDatePicker: React.FC<IUsageDatePickerProps> = ({
  onRangeChange,
  defaultValue,
  disabledGranularity,
}) => {
  const vsiDuration =
    useSelector(featureSelector(usageDashboardFeatureNames.VSI_DATA_ACCESS_DURATION)) || 13;
  const dpiDuration =
    useSelector(featureSelector(usageDashboardFeatureNames.DPI_DATA_ACCESS_DURATION)) || 13;
  // CE-11871 : Usage dashboard is shared across VSI and DPI, but each product has a different
  // data access duration. Take the max so the calendar limit is consistent regardless
  // of which product the dashboard is opened from.
  const durationAllowed = Math.max(vsiDuration, dpiDuration);
  const disabledDate = (current) => {
    const calendarDateMoment = utcMoment(current);
    return (
      (calendarDateMoment && calendarDateMoment > utcMoment().endOf('month')) ||
      current.isBefore(moment().subtract(durationAllowed, 'months'), 'month')
    );
  };

  const rangePresets: any = [
    { label: 'This Month', value: [utcMoment().startOf('month'), utcMoment().startOf('day')] },
    {
      label: 'Last Month',
      value: [
        utcMoment().subtract(1, 'month').startOf('month'),
        utcMoment().subtract(1, 'month').endOf('month'),
      ],
    },
    {
      label: 'Past 1 Year',
      value: [
        utcMoment().subtract(1, 'year').startOf('day'),
        utcMoment().subtract(1, 'day').endOf('day'),
      ],
    },
  ];
  return (
    <Space>
      <GranularityPicker disabled={disabledGranularity}></GranularityPicker>
      <RangePicker
        presets={rangePresets}
        onChange={onRangeChange}
        picker="month"
        disabledDate={disabledDate}
        defaultValue={defaultValue}
        style={{ backgroundColor: '#e9edf0' }}
      />
      <Kebab></Kebab>
    </Space>
  );
};

export default UsageDatePicker;
